import { render } from "./NewPassword.vue?vue&type=template&id=5a8158ee&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5a8158ee"

export default script